import APIClient from './index';

export const getAllDeals = (params = {}) =>
  new Promise((resolve, reject) =>
    APIClient.get(`/deals?${new URLSearchParams(params).toString()}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const addDeal = (data) =>
  new Promise((resolve, reject) =>
    APIClient.post(`/deals`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const getDeal = (id) =>
  new Promise((resolve, reject) =>
    APIClient.get(`/deals/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const deleteDeal = (deal) =>
  new Promise((resolve, reject) =>
    APIClient.delete(`/deals/${deal.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );

export const updateDeal = (deal, updates) =>
  new Promise((resolve, reject) =>
    APIClient.put(`/deals/${deal.id}`, updates)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );
